<template>
  <base-layout page-default-back-link="/home">
    <ion-row style="padding: 0px; text-align: center"
      ><ion-col size="12"
        ><h3>{{ Anteprima.Titolo }}</h3></ion-col
      >
    </ion-row>

    <ion-row style="padding: 0px; text-align: center" v-if="Anteprima.Inf_posi == 1">
      <ion-col size="12">
        <div v-if="Anteprima.Inf_dimi != '0px'"><img v-bind:src="$SITE_URL + Anteprima.Inf_imag" style="max-height: 200px" /></div>
        <div style="padding-left: 40px !important"><p v-html="Anteprima.Info"></p></div>
      </ion-col>
    </ion-row>

    <!-- immagine a destra e testo a sinistra -->
    <ion-row style="padding: 0px; text-align: center" v-if="Anteprima.Inf_posi == 2">
      <ion-col size="12">
        <div :style="{ float: 'right', width: Anteprima.Inf_dimi, 'margin-left': '10px' }" v-if="Anteprima.Inf_dimi != '0px'">
          <img v-bind:src="$SITE_URL + Anteprima.Inf_imag" :style="{ width: Anteprima.Inf_dimi }" />
        </div>
        <div style="float: none"><p align="justify" v-html="Anteprima.Info"></p></div>
      </ion-col>
    </ion-row>

    <ion-row style="padding: 0px; text-align: center">
      <ion-col size="12">
        <!-- immagine sotto e testo sopra -->
        <div v-if="Anteprima.Inf_posi == 3" style="width: 100%">
          <div style="float: none"><p v-html="Anteprima.Info"></p></div>
          <div class="center" v-if="Anteprima.Inf_dimi != '0px'">
            <img mg v-bind:src="$SITE_URL + Anteprima.Inf_imag" style="width: 100%; max-width: 200px" />
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row style="padding: 0px; text-align: center" v-if="Anteprima.Inf_posi == 4">
      <ion-col size="12">
        <!-- immagine a sinistra e testo a destra -->

        <div :style="{ float: 'left', width: Anteprima.Inf_dimi, 'margin-right': '10px' }" v-if="Anteprima.Inf_dimi != '0px'">
          <img mg v-bind:src="$SITE_URL + Anteprima.Inf_imag" :style="{ width: Anteprima.Inf_dimi }" />
        </div>
        <div style="float: none"><p align="justify" v-html="Anteprima.Info"></p></div>
      </ion-col>
    </ion-row>

    <ion-list>
      <div v-for="item in arcSezioni" :key="item.sezione" style="padding-left: 30px">
        <ion-item lines="none" v-if="item.sezione">
          <router-link :to="{ name: 'InformazioniDet', params: { pIns_grup: item.sezione } }" style="font-weight: bold; text-decoration: none; color: blue">{{
            item.sezione
          }}</router-link>
        </ion-item>
      </div>
    </ion-list>
  </base-layout>
</template>

<script>
import { BaseLayout, IonList, IonItem, IonRow, IonCol } from "@ionic/vue";

import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";

export default {
  name: "HomePageInformazioni",
  components: {
    BaseLayout,
    IonList,
    IonItem,
    IonRow,
    IonCol,
  },
  data() {
    return {
      arcSezioni: [],
      Anteprima: {},
    };
  },
  methods: {
    GetPulsanti() {
      const self = this;
      let prm = [];
      // inline
      prm.push(new CommandParam("@Lin_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.$LIN_CODI));
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(prm, "stpF_Anagrafica_Indirizzi_info_Anteprima02_lst", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data && data.RecordSet.Table.length > 0) {
            self.Anteprima = data.RecordSet.Table[0];
            self.arcSezioni = data.RecordSet.Table1;
          } else {
            self.arcSezioni = [];
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
  mounted() {
    this.GetPulsanti();
  },
};
</script>
